/**
 * More ol3-centric styling format to replace the "image" styler
 */
import ol = require("openlayers");
import { StyleConverter } from "ol3-symbolizer/index";
const converter = new StyleConverter();

converter.setGeometry = (feature: ol.Feature) => {
  let geom = feature.getGeometry();
  if (geom instanceof ol.geom.Polygon) {
    let attrs = feature.get("attributes");
    if (attrs && attrs["image-center"]) {
      let coord = JSON.parse(attrs["image-center"]);
      if (ol.extent.containsCoordinate(geom.getExtent(), coord)) {
        geom = new ol.geom.Point(coord);
      } else {
        geom = geom.getInteriorPoint();
      }
    } else {
      geom = geom.getInteriorPoint();
    }
  }
  return geom;
};

export = converter;
